export const marketTrendsLegendStyles = `
  .market-trends-legend {
    position: absolute;
    bottom: 24px;
    left: 10px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    z-index: 100;
    font-size: 11px;
    display: none;
    width: 220px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .market-trends-legend.visible {
    display: block;
  }

  .market-trends-legend-header {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .market-trends-metric-select {
    flex: 1;
    min-width: 0;
    font-weight: 600;
    color: #1f2937;
    font-size: 11px;
    font-family: inherit;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: #f9fafb;
    padding: 2px 4px;
  }

  .market-trends-legend-scope {
    color: #6b7280;
    flex-shrink: 0;
  }

  .market-trends-legend-subtitle {
    color: #6b7280;
    margin-top: 2px;
    margin-bottom: 8px;
  }

  .market-trends-info-btn {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 50%;
    border: 1px solid #9ca3af;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    line-height: 1;
  }

  .market-trends-info-btn:hover {
    background: #e5e7eb;
    border-color: #6b7280;
    color: #374151;
  }

  .market-trends-gradient {
    height: 12px;
    border-radius: 3px;
  }

  .market-trends-gradient-labels {
    display: flex;
    justify-content: space-between;
    color: #374151;
    margin-top: 3px;
  }

  .market-trends-no-data-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e5e7eb;
    color: #374151;
  }

  .market-trends-no-data-swatch {
    width: 16px;
    height: 16px;
    border-radius: 3px;
    flex-shrink: 0;
  }

  /* Info popup */
  .market-trends-info-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    max-width: 380px;
    font-size: 13px;
  }

  .market-trends-info-popup h3 {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #1f2937;
  }

  .market-trends-info-popup p {
    margin: 8px 0;
    color: #4b5563;
    line-height: 1.5;
  }

  .market-trends-info-popup .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 24px;
    height: 24px;
    border: none;
    background: #f3f4f6;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
    color: #6b7280;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .market-trends-info-popup .close-btn:hover {
    background: #e5e7eb;
    color: #374151;
  }

  .market-trends-info-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
`;
//# sourceMappingURL=styles.js.map